<template>
  <el-dialog
      title="Check CIC"
      :visible.sync="dialogVisible"
      width="40%"
      center
      style="right: 12px !important;"
      append-to-body
  >
    <div class="row">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe
            class="embed-responsive-item"
            :class="{'video-cic': !isYoutube}"
            :src="videoSrc"
            allowfullscreen
        ></iframe>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "DialogCheckCicVideo",
  props: {
    checkCicDialogVisible: {
      type: Boolean,
      default: false,
    },
    videoSrc: {
      type: String,
      default: "/media/video/cic.mp4",
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.checkCicDialogVisible;
      },
      set(value) {
        this.$emit("update:checkCicDialogVisible", value);
      },
    },
    isYoutube() {
      return this.videoSrc.includes("youtube.com") || this.videoSrc.includes("youtu.be");
    },
  },
};
</script>

<style scoped>

</style>
